import { SVGProps } from "react";

const DeactivateIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="icono-desactivar"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.00002 11.5999C9.09282 11.5999 11.6 9.0927 11.6 5.9999C11.6 2.90711 9.09282 0.399902 6.00002 0.399902C2.90723 0.399902 0.400024 2.90711 0.400024 5.9999C0.400024 9.0927 2.90723 11.5999 6.00002 11.5999ZM3.90002 5.2999C3.51343 5.2999 3.20002 5.6133 3.20002 5.9999C3.20002 6.3865 3.51343 6.6999 3.90002 6.6999H8.10003C8.48662 6.6999 8.80002 6.3865 8.80002 5.9999C8.80002 5.6133 8.48662 5.2999 8.10003 5.2999H3.90002Z"
        fill="#6B7280"
      />
    </svg>
  );
};

export default DeactivateIcon;
